import {translate} from "../../common/Translator";
import * as BSEntities from "../../constants/BSEntities";
import {ReferenceWidget} from "../../widgets/ReferenceWidget";
import * as NamaURLS from "../../constants/NamaURLS";
import {ajaxJSON} from "../../common/NamaCommon";
import * as DomainBaseFieldIDs from "../../constants/DomainBaseFieldIDs";
import {JSCriteriaBuilder} from "../../common/JSCriteriaBuilder";
import {addArabicEnglishToData} from "./CriteriaEditorWidget";
import {dropDownFiltering} from "../../widgets/DropDownListWidget";

export class ListViewSortByBar {
    constructor(presenter, container) {
        let that = this;
        that.presenter = presenter;
        that.container = container;
    }

    get sortOnField() {
        return this.container.find("#sortOn").data("kendoDropDownList").value();
    }

    set sortOnField(value) {
        return this.container.find("#sortOn").data("kendoDropDownList").value(value);
    }

    get sortThen1() {
        return this.container.find("#sortThen1").data("kendoDropDownList").value();
    }

    set sortThen1(value) {
        return this.container.find("#sortThen1").data("kendoDropDownList").value(value);
    }

    get sortThen2() {
        return this.container.find("#sortThen2").data("kendoDropDownList").value();
    }

    set sortThen2(value) {
        return this.container.find("#sortThen2").data("kendoDropDownList").value(value);
    }

    get ascending() {
        let value = this.container.find("#ascOrDesc").data("kendoDropDownList").value();
        return value === "asc";
    }

    set ascending(asc) {
        let ascValue = "asc";
        if (!asc || asc === "false")
            ascValue = "desc";
        this.container.find("#ascOrDesc").data("kendoDropDownList").value(ascValue);
    }

    calcSortBy() {
        let that = this;
        let sortBy = "";
        sortBy += that.sortOnField ? that.sortOnField : "";
        let secondSortBy = that.sortThen1;
        if (secondSortBy && !sortBy.contains(secondSortBy))
            sortBy += "," + secondSortBy;
        let thirdSortBy = that.sortThen2;
        if (thirdSortBy && !sortBy.contains(thirdSortBy))
            sortBy += "," + thirdSortBy;
        return sortBy;
    }

    render() {
        let that = this;
        let viewsField = that.container.find("#views");
        let sortOnField = that.container.find("#sortOn");
        let sortThen1 = that.container.find("#sortThen1");
        let sortThen2 = that.container.find("#sortThen2");
        let ascOrDesc = that.container.find("#ascOrDesc");
        that.model = kendo.data.Model.define({});
        Object.defineProperty(that.model.prototype, "$translatedFieldId", {
            enumerable: false, configurable: true, get: function () {
                return translate(this.id, that.presenter.entityType);
            }, set: function (value) {
            }
        });
        viewsField.kendoDropDownList(that.getViewNames());
        sortOnField.kendoDropDownList(that.sortByOptions());
        sortThen1.kendoDropDownList(that.sortByOptions());
        sortThen2.kendoDropDownList(that.sortByOptions());
        let ascOrDescData = [{id: "asc"}, {id: "desc"}];
        addArabicEnglishToData(ascOrDescData);
        ascOrDesc.kendoDropDownList({
            filter: "contains",
            dataSource: new kendo.data.DataSource({
                data: ascOrDescData,
                schema: {
                    model: that.model
                }
            }),
            value: ascOrDescData[0].id,
            dataTextField: "$translatedFieldId",
            dataValueField: "id",
            change: e => {
                that.presenter.place.ascending = that.ascending;
                that.presenter.onListView();
            },
            filtering: function (ev) {
                dropDownFiltering(ev, this.dataSource);
            },
        });
        let widget = new ReferenceWidget({
            owner: that,
            fieldMetadata: {fieldId: "extraCriteria", referencedEntityType: BSEntities.CriteriaDefinition},
            width: 20
        });
        widget.extraCriteria = new JSCriteriaBuilder().field(DomainBaseFieldIDs.CriteriaDefinition_forType).equal(that.presenter.entityType).and()
            .field(DomainBaseFieldIDs.CriteriaDefinition_useInList).equal("true").build();
        widget.render().appendTo(that.container.find("#extraCriteriaContainer"));
        widget.afterAttach();
        let place = that.presenter.place;
        let orderBy = that.presenter.getOrderBy();
        let asc = that.presenter.place.ascending;
        if (asc === false) {
            that.presenter.place.ascending = asc;
        }
        that.container.find("#views").data("kendoDropDownList").value(that.presenter.place.listViewName);
        if (orderBy) {
            that.presenter.place.sortBy = orderBy;
            let sortByList = orderBy.split(",");
            if (sortByList.length) {
                if (sortByList[0])
                    that.sortOnField = sortByList[0];
                if (sortByList[1])
                    that.sortThen1 = sortByList[1];
                if (sortByList[2])
                    that.sortThen2 = sortByList[2];
            }
        }
        that.ascending = place.ascending;
        if (place.extraCriteria) {
            ajaxJSON(NamaURLS.FIND_REF_BY_ID, {
                entityType: BSEntities.CriteriaDefinition,
                id: place.extraCriteria
            }, (ref) => {
                that.extraCriteriaWidget.oldValue = ref;
                that.extraCriteriaWidget.setValueInElement(ref);
            })
        }
    }

    getViewNames() {
        let that = this;
        let viewNames = that.presenter.viewNames;
        return {
            dataSource: new kendo.data.DataSource({
                data: viewNames,
                schema: {
                    model: that.model
                }
            }),
            dataTextField: "text",
            dataValueField: "value",
            filter: "contains",
            change: e => {
                that.presenter.setViewName(this.container.find("#views").data("kendoDropDownList").value());
            }
        };
    }

    sortByOptions() {
        let that = this;
        let sortColumns = that.presenter.preferences.listLayout.sortColumns;
        return {
            dataSource: new kendo.data.DataSource({
                data: sortColumns,
                schema: {
                    model: that.model
                }
            }),
            dataTextField: "$translatedFieldId",
            dataValueField: "id",
            filter: "contains",
            change: e => {
                that.presenter.place.sortBy = that.calcSortBy();
                that.presenter.onListView();
            }
        };
    }

    onDataChanged(fieldId, fieldValue) {
        let that = this;
        that.presenter.place.extraCriteria = fieldValue ? fieldValue.id : null;
        that.presenter.onListView();
    }

    addDataWidget(widget) {
        this.extraCriteriaWidget = widget;
    }

    rootElement() {
        return this.container;
    }
}